export { default } from './section-label';
